// Paid sign-up: the account is only created after the payment is confirmed.
// Until then the checkout works with the token of the pending registration
// (POST billing/guest/register), kept for the current browser tab only.

const STORAGE_KEY = 'be.checkout.registration';

export interface GuestRegistration {
  token: string;
  productId: number;
  priceId: number;
  // prefill the M-Pesa number / the sign-up form when going back
  phone?: string;
  email?: string;
}

export function storeGuestRegistration(registration: GuestRegistration) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(registration));
  } catch {
    // storage unavailable (private mode), checkout will ask to sign up again
  }
}

export function getGuestRegistration(
  productId?: string | number,
  priceId?: string | number,
): GuestRegistration | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    const registration = value ? (JSON.parse(value) as GuestRegistration) : null;
    if (
      registration?.token &&
      (productId == null || `${registration.productId}` === `${productId}`) &&
      (priceId == null || `${registration.priceId}` === `${priceId}`)
    ) {
      return registration;
    }
  } catch {
    //
  }
  return null;
}

// Sign-up form as typed, so "Back" from checkout shows it filled in again.
// Kept in memory only (never in storage) because it holds the password;
// a page reload clears it.
export interface GuestSignupDraft {
  email: string;
  password: string;
  password_confirmation: string;
  phone: string;
  termsAccepted: boolean;
}

let signupDraft: GuestSignupDraft | null = null;

export function setGuestSignupDraft(draft: GuestSignupDraft) {
  signupDraft = draft;
}

export function getGuestSignupDraft(): GuestSignupDraft | null {
  return signupDraft;
}

export function clearGuestRegistration() {
  signupDraft = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    //
  }
}
